import { useState, useEffect } from "react";
import { useMediaQuery } from "@mui/material";
import husibuechThemeDark from "../theme/DarkTheme";
import husibuechTheme from "../theme/Theme";

export default function useAppTheme() {
  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");
  const [appInDarkMode, setAppInDarkMode] = useState(true);

  useEffect(() => {
    setAppInDarkMode(true);
  }, [prefersDarkMode]);

  const theme = appInDarkMode ? husibuechThemeDark : husibuechTheme;

  return { theme, appInDarkMode, setAppInDarkMode };
}
